import { createSlice } from '@reduxjs/toolkit'

const reducerName = 'modals'

/**
 * {Object} modal
 * {string} modal.id
 * {string} modal.type
 * {string} modal.title
 * {ReactObject} modal.content
 * {string[]} [modal.buttons]
 * {Object} modal.functions
 * {Object} [modal.eventModal]
 * {Object} [modal.enableBgExit]
 * {Object} [modal.enableModalExit]
 */

const initialState = []

const modalsSlice = createSlice({
  name: reducerName,
  initialState,
  reducers: {
    addNewModal(state, action) {
      const { payload } = action

      const existingModal = state.find(
        (modal) => modal.id === action.payload.id
      )

      if (!existingModal) {
        state.push(payload)
      } else {
        const index = state.findIndex((modal) => modal.id === payload.id)

        // state[index] = {
        //   ...state[index],
        //   ...payload,
        // }

        state[index].content = payload.content
      }
    },

    closeModalById(state, action) {
      return state.filter((modal) => modal.id !== action.payload)
    },

    closeAllModals() {
      return []
    },
  },
})

const { addNewModal, closeModalById, closeAllModals } = modalsSlice.actions

export const modalsActions = {
  addNewModal,
  closeModalById,
  closeAllModals,
}

export const { reducer: modalsReducer } = modalsSlice
